// extracted by mini-css-extract-plugin
export default {"wrapper":"HorseListPlaceholder_wrapper__4T0NX","msg":"HorseListPlaceholder_msg__HsjC0","footer":"HorseListPlaceholder_footer__SInHB"};